import * as React from "react";
import { message, Row, Col, Input, Select, Button, Form } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";

interface BillingContactsSelectionProps extends WithTranslation {
  value?: API_BillingContact[];
  onChange?: (v: API_BillingContact[]) => API_BillingContact[];
}

interface GUIBillingContact extends API_BillingContact {
  uid: number;
}

interface BillingContactsSelectionState {
  type: API_BILLINGCONTACT_TYPE;
  value: string;
  list: GUIBillingContact[];
}

export const BillingContactsSelection = withTranslation(I18N_NS.ADMIN)(
  class extends React.Component<BillingContactsSelectionProps, BillingContactsSelectionState> {
    constructor(props: BillingContactsSelectionProps) {
      super(props);
      this.state = {
        type: "CONTACT",
        value: "",
        list: [],
      };
    }

    componentDidMount() {
      if (this.props.value) {
        this.setState({ list: this.props.value.map((item) => ({ ...item, uid: item.id })) });
      }
    }

    handleContactAdd = () => {
      const { onChange, t } = this.props;
      const { type, value } = this.state;

      if (typeof onChange !== "function") {
        console.warn("onChange is not define");
        return;
      }

      if (!value) {
        message.error(t("Fill contact name field"));
        return;
      }

      const newItem: GUIBillingContact = { type, value, uid: new Date().getTime() };

      this.setState({ list: [...this.state.list, newItem] }, () => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onChange(this.state.list.map(({ uid: _, ...item }) => item));
      });
    };

    handleRemoveContact = (contactUid: number) => {
      const { onChange } = this.props;

      this.setState({ list: this.state.list.filter((item) => item.uid !== contactUid) }, () => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onChange(this.state.list.map(({ uid: _, ...item }) => item));
      });
    };

    renderAddContactForm = () => {
      const { t } = this.props;
      return (
        <Row justify="start" gutter={20}>
          <Col xs={24} md={6} className="mb-2">
            <Input
              placeholder={t("Name")}
              onChange={(e) => {
                const { value } = e.target;
                this.setState({ value });
              }}
            />
          </Col>
          <Col xs={24} md={6} className="mb-2">
            <Select
              placeholder={t("For")}
              onChange={(type) => {
                this.setState({ type: type as API_BILLINGCONTACT_TYPE });
              }}
              defaultValue={"CONTACT"}
            >
              <Select.Option key={"BILLING"} value={"BILLING"}>
                {t("Billing")}
              </Select.Option>
              <Select.Option key={"CONTACT"} value={"CONTACT"}>
                {t("Contract")}
              </Select.Option>
              <Select.Option key={"SALES"} value={"SALES"}>
                {t("Sales")}
              </Select.Option>
            </Select>
          </Col>
          <Col xs={24} md={4} className="mb-2">
            <Button type="primary" onClick={() => this.handleContactAdd()}>
              {t("Add new contact")}
            </Button>
          </Col>
        </Row>
      );
    };

    renderContactList = (billType: API_BILLINGCONTACT_TYPE) => {
      const { t } = this.props;
      const currentContactsList = this.state.list.filter((contact) => contact.type === billType);

      return currentContactsList.length ? (
        currentContactsList.map((item, index) => {
          return (
            <div key={index}>
              <Row justify="space-between" style={{ borderBottom: "1px solid #e4e4e4" }}>
                <Col style={{ color: "grey" }}>{item.value}</Col>
                <Col onClick={() => this.handleRemoveContact(item.uid)} style={{ cursor: "pointer" }}>
                  <FontAwesomeIcon icon={["far", "times"]} />
                </Col>
              </Row>
            </div>
          );
        })
      ) : (
        <span style={{ color: "grey" }}>{t("No contacts")}</span>
      );
    };

    render() {
      const { t } = this.props;
      return (
        <>
          <Row gutter={20} justify="space-between" className="mb-lg">
            <Col xs={24} md={6}>
              <Form.Item label={t("Contact person billing")}>{this.renderContactList("BILLING")}</Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label={t("Contact person contract")}>{this.renderContactList("CONTACT")}</Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label={t("Contact person sales")}>{this.renderContactList("SALES")}</Form.Item>
            </Col>
          </Row>

          {this.renderAddContactForm()}
        </>
      );
    }
  }
);
